import { render } from "./Training.vue?vue&type=template&id=ca744752&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"

import "./Training.vue?vue&type=style&index=0&id=ca744752&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ca744752"

export default script